<script lang="ts">
    // @ts-ignore
    import dayjs from "dayjs";
    import {
        S3Client,
        AbortMultipartUploadCommand,
        ListBucketsCommand,
        ListObjectsCommand,
        UploadPartCommand,
        PutObjectCommand,
    } from "@aws-sdk/client-s3";
    import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
    // @ts-ignore
    import bulmaCalendar from "bulma-calendar";
    import { onMount } from "svelte";
    import { useNavigate } from "svelte-navigator";
    import { contentStore } from "../../../../../store/contents";
    import type {
        ContentListEntry,
        DayOfWeek,
        PlayerListEntry,
    } from "../../../../../../admin-service-typescript-client";
    import { ApiClient } from "../../../../../GlobalHelper/ApiClient";
    import { LocalDateTimeFormat } from "../../../../../settings/settings";
    import { user } from "../../../../../store/stores";
    import CampaignGeoSelect from "./CampaignGeoSelect.svelte";
    import CampaignStationList from "./CampaignLocationList.svelte";
    import TimeSlotTable from "./NewCampaignTimeslotTable.svelte";
    import ContentCard from "./ContentCard.svelte";

    type baseCampaign = {
        name: string;
        duration: {
            start: string;
            end: string;
            timeZone: string;
        };
        active: boolean;
        contents: string[];
        timePlan: {
            dayOfWeek: DayOfWeek;
            from: string;
            to: string;
        }[];
        targetPlayers: string[];
    };

    export let changeCampaignHandler: (
        index: number,
        campaign: baseCampaign
    ) => void;

    export let campaign: baseCampaign;
    export let newCampaignItemhandler: () => void;
    export let index: number;

    const navigate = useNavigate();
    let newContentModalOpen = false;
    let newContentUrl = "";
    let newContentName = "";
    let showCampaignNameInput = false;
    let mapModalActive = false;
    let graphLabels: string[] = [];
    let iconAsc = "↑";
    let iconDesc = "↓";
    let sortBy = "id";
    let sortOrder = 1;
    let rows = [];
    let loading = true;
    let searchObject: { [key: string]: any } = { creativeId: "" };
    let contentArray: ContentListEntry[] = [];
    let files;
    let stationsFile;
    let client: S3Client;
    let uploading = false;
    let message = "";

    let generalCardOpen = true;
    let stationsCardOpen = true;
    let timetableCardOpen = false;
    let contentCardOpen = false;

    let selectedContentIds = [];
    let selectedPlayerIds = [];
    let timeTable = [];

    let step = 1;

    let activeState = false;
    let campaignName = "";
    let campaignStart = "";
    let campaignEnd = "";
    let campaigns: {
        name: string;
        [key: string]: any;
    }[] = [];
    let fetching: boolean = false;
    let status: boolean | null = null;
    let errorMessage: string = "Die Erstellung ist fehlgeschlagen.";
    let playerList: PlayerListEntry[] = [];
    let addPlayers: (players: PlayerListEntry[]) => void = (players) => {
        playerList = [
            ...playerList,
            ...players.filter(
                (item) => !playerList.find((station) => station.id === item.id)
            ),
        ];
        updateCampaignPlayer();
    };
    let removePlayers: (players: PlayerListEntry[]) => void = (players) => {
        playerList = [
            ...playerList.filter(
                (item) => !players.find((station) => station.id === item.id)
            ),
        ];
        updateCampaignPlayer();
    };

    const updateCampaignPlayer = () => {
        campaign.targetPlayers = playerList.map((player) => player.id);
    };

    let contentList: ContentListEntry[] = [];
    let addContent: (content: ContentListEntry) => void = (content) => {
        contentList = [
            ...contentList.filter((item) => content.id !== item.id),
            content,
        ];
    };
    let removeContent: (content: ContentListEntry) => void = (content) => {
        contentList = [...contentList.filter((item) => content.id !== item.id)];
    };

    const createNewContent = async () => {
        if (!newContentUrl || !newContentName) {
            alert("Beide Felder müssen ausgefüllt sein.");
            return;
        }
        newContentModalOpen = false;
        await ApiClient.getInstance($user)
            .contentClient.createContent({
                contentRequest: {
                    url: newContentUrl,
                    active: true,
                    name: newContentName,
                    // tags: [{ id: "name", values: [newContentName] }],
                },
            })
            .then(console.log);
        getCreatives();
    };

    const uploadFile = async () => {
        uploading = true;
        if (!files.length) {
            return alert("Please choose a file to upload first.");
        }
        var file = files[0];
        var fileName = file.name;

        var photoKey = fileName;
        const uploadParams = {
            Bucket: "dev-bucket-whizad",
            Key: photoKey,
            Body: file,
        };

        // Use S3 ManagedUpload class as it supports multipart uploads
        await client
            .send(new PutObjectCommand(uploadParams))
            .then((res) => {
                uploading = false;
                message = "Datei erfolgreich gespeichert";
                newContentUrl = `https://dev-bucket-whizad.s3.eu-central-1.amazonaws.com/${fileName}`;
            })
            .catch((err) => {
                uploading = false;
                message = err;
            });
        // var promise = upload.promise();

        // promise.then(
        //     function (data) {
        //         alert("Successfully uploaded photo.");
        //         viewAlbum(albumName);
        //     },
        //     function (err) {
        //         return alert(
        //             "There was an error uploading your photo: ",
        //             err.message
        //         );
        //     }
        // );
    };

    const getCreatives = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .contentClient.listContents({ size: 100 })
                .then((content) =>
                    contentStore.update((contentStore) => {
                        return {
                            ...contentStore,
                            contents: content,
                        };
                    })
                );
        });
    };

    onMount(() => {
        let calendar = new bulmaCalendar("#calendar" + index, {
            type: "datetime",
            isRange: true,
        });
        calendar.on("select", function (some) {
            const dates = some.data.value().split("-");
            campaignEnd = dayjs(dates[1]).format(LocalDateTimeFormat);
            campaignStart = dayjs(dates[0]).format(LocalDateTimeFormat);
            console.log(some, campaignStart, campaignEnd);
        });
        // calendar.on(
        //     "select:start",
        //     (datepicker) => {
        //         console.log(
        //             datepicker.data.value(),
        //             datepicker.starDate.value()
        //         );
        //     }
        //     // campaignStart = dayjs(date.data.datePicker._start).format(
        //     //     LocalDateTimeFormat
        //     // );
        //     // console.log(date, date.data.datePicker);
        // );
        // calendar.on("select", (date) => {
        //     campaignEnd = dayjs(date.data.datePicker._end).format(
        //         LocalDateTimeFormat
        //     );
        //     console.log(campaignEnd, date.data.value());
        // });
        getCreatives();
        client = new S3Client({
            region: "eu-central-1",

            credentials: fromCognitoIdentityPool({
                clientConfig: { region: "eu-central-1" }, // Configure the underlying CognitoIdentityClient.
                identityPoolId:
                    "eu-central-1:2aaaf671-27fb-43df-9f0c-7584249d5f23",
            }),
        });
    });
</script>

<div class="card">
    <header class="card-header gradient-left">
        <p
            class="card-header-title c-pointer f-white mb-0"
            on:click={() => (showCampaignNameInput = true)}
        >
            {#if !showCampaignNameInput}
                {campaign.name ? campaign.name : "Variation " + (index + 1)}
            {:else}
                <form
                    on:submit|preventDefault={() =>
                        (showCampaignNameInput = false)}
                >
                    <input
                        class="f-white b-seethrough"
                        bind:value={campaign.name}
                        placeholder="Kampagnenname"
                    />
                </form>
            {/if}
        </p>
        <button
            class="card-header-icon"
            aria-label="more options"
            on:click={newCampaignItemhandler}
        >
            <span class="icon">
                <i class="fas fa-plus" aria-hidden="true" />
            </span>
        </button>
    </header>
    <div class="card-content">
        <div class="content">
            <div class="columns is-multiline">
                <div class="column is-6">
                    <div class="card">
                        <header class="card-header gradient-left">
                            <p class="card-header-title f-white mb-0">
                                {"Grundeinstellungen"}
                            </p>
                            {#if !generalCardOpen}
                                <button
                                    class="card-header-icon"
                                    aria-label="more options"
                                    on:click={() => (generalCardOpen = true)}
                                >
                                    <span class="icon">
                                        <i
                                            class="fas fa-angle-down"
                                            aria-hidden="true"
                                        />
                                    </span>
                                </button>
                            {:else}
                                <button
                                    class="card-header-icon"
                                    aria-label="more options"
                                    on:click={() => (generalCardOpen = false)}
                                >
                                    <span class="icon">
                                        <i
                                            class="fas fa-angle-up"
                                            aria-hidden="true"
                                        />
                                    </span>
                                </button>
                            {/if}
                        </header>
                        <div class="card-content">
                            <div class="content">
                                <div class="field is-horizontal">
                                    <div class="field-label is-normal">
                                        <!-- svelte-ignore a11y-label-has-associated-control -->
                                        <label class="label">Status</label>
                                    </div>
                                    <div class="field-body">
                                        <div class="field">
                                            <div class="select">
                                                <select
                                                    bind:value={campaign.active}
                                                >
                                                    <option value={true}
                                                        >aktiv</option
                                                    >
                                                    <option value={false}
                                                        >deaktiviert</option
                                                    >
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="field is-horizontal">
                                    <div class="field-label is-normal">
                                        <!-- svelte-ignore a11y-label-has-associated-control -->
                                        <label class="label">Laufzeit</label>
                                    </div>
                                    <div class="field-body">
                                        <div class="field">
                                            <p class="control full-1_75rem">
                                                <input
                                                    id={"calendar" + index}
                                                />
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column is-6">
                    <div class="card">
                        <header class="card-header gradient-left">
                            <p class="card-header-title f-white mb-0">
                                {"Stationsauswahl"}
                            </p>
                            {#if !stationsCardOpen}
                                <button
                                    class="card-header-icon"
                                    aria-label="more options"
                                    on:click={() => (stationsCardOpen = true)}
                                >
                                    <span class="icon">
                                        <i
                                            class="fas fa-angle-down"
                                            aria-hidden="true"
                                        />
                                    </span>
                                </button>
                            {:else}
                                <button
                                    class="card-header-icon"
                                    aria-label="more options"
                                    on:click={() => (stationsCardOpen = false)}
                                >
                                    <span class="icon">
                                        <i
                                            class="fas fa-angle-up"
                                            aria-hidden="true"
                                        />
                                    </span>
                                </button>
                            {/if}
                        </header>
                        <div class="card-content">
                            <div class="content">
                                <div class="card-flex">
                                    <div class="columns">
                                        <div class="column flex">
                                            <div class="field">
                                                <!-- svelte-ignore a11y-label-has-associated-control -->
                                                <div class="control">
                                                    <input
                                                        type="file"
                                                        placeholder="Stations IDs"
                                                        accept=".csv"
                                                        bind:files={stationsFile}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="column flex">
                                            <!-- svelte-ignore a11y-missing-attribute -->
                                            <a
                                                on:click={() =>
                                                    (mapModalActive = true)}
                                                >Kartenansicht ></a
                                            >
                                        </div>
                                    </div>

                                    <div
                                        class={`modal ${
                                            mapModalActive ? "is-active" : ""
                                        }`}
                                    >
                                        <div
                                            class="modal-background"
                                            on:click={() =>
                                                (mapModalActive = false)}
                                        />
                                        <div
                                            class="modal-content  modal-stations"
                                        >
                                            <div class="card">
                                                <div class="card-content">
                                                    <div class="content">
                                                        <div class="columns">
                                                            <div
                                                                class="column is-7"
                                                            >
                                                                {#if mapModalActive}
                                                                    <CampaignGeoSelect
                                                                        onDeselect={removePlayers}
                                                                        onSelect={addPlayers}
                                                                        selectedPlayers={playerList}
                                                                    />
                                                                {/if}
                                                            </div>
                                                            <div
                                                                class="column is-5"
                                                            >
                                                                <CampaignStationList
                                                                    onDeselect={removePlayers}
                                                                    onSelect={addPlayers}
                                                                    selectedPlayers={playerList}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <button
                                                class="modal-close is-large"
                                                aria-label="close"
                                                on:click={() =>
                                                    (mapModalActive = false)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column is-12" style="z-index: 0;">
                    <div class="card">
                        <header class="card-header gradient-left">
                            <p class="card-header-title f-white mb-0">
                                {"Tage & Uhrzeiten"}
                            </p>
                            {#if !timetableCardOpen}
                                <button
                                    class="card-header-icon"
                                    aria-label="more options"
                                    on:click={() => (timetableCardOpen = true)}
                                >
                                    <span class="icon">
                                        <i
                                            class="fas fa-angle-down"
                                            aria-hidden="true"
                                        />
                                    </span>
                                </button>
                            {:else}
                                <button
                                    class="card-header-icon"
                                    aria-label="more options"
                                    on:click={() => (timetableCardOpen = false)}
                                >
                                    <span class="icon">
                                        <i
                                            class="fas fa-angle-up"
                                            aria-hidden="true"
                                        />
                                    </span>
                                </button>
                            {/if}
                        </header>
                        {#if timetableCardOpen}
                            <div class="card-content">
                                <div class="content">
                                    <div class="card-flex">
                                        <TimeSlotTable
                                            onChangeCallback={(
                                                newTimetable
                                            ) => {
                                                campaign.timePlan =
                                                    newTimetable;
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        {/if}
                    </div>
                </div>
                <div class="column is-12">
                    <div class="card">
                        <header class="card-header gradient-left">
                            <p class="card-header-title f-white mb-0">
                                {"Content"}
                            </p>
                            {#if !contentCardOpen}
                                <button
                                    class="card-header-icon"
                                    aria-label="more options"
                                    on:click={() => (contentCardOpen = true)}
                                >
                                    <span class="icon">
                                        <i
                                            class="fas fa-angle-down"
                                            aria-hidden="true"
                                        />
                                    </span>
                                </button>
                            {:else}
                                <button
                                    class="card-header-icon"
                                    aria-label="more options"
                                    on:click={() => (contentCardOpen = false)}
                                >
                                    <span class="icon">
                                        <i
                                            class="fas fa-angle-up"
                                            aria-hidden="true"
                                        />
                                    </span>
                                </button>
                            {/if}
                        </header>
                        {#if contentCardOpen}
                            <div class="card-content">
                                <div class="content">
                                    <div class="card-flex">
                                        <div
                                            class="columns is-vcentered is-multiline"
                                        >
                                            <div class="column is-2">
                                                <p
                                                    class="is-5 greenish-plus"
                                                    on:click={() =>
                                                        (newContentModalOpen = true)}
                                                >
                                                    +
                                                </p>
                                            </div>
                                            <div class="column is-3 ">
                                                <p class="is-5 greenish">
                                                    Content
                                                </p>
                                            </div>
                                            <div class="column is-3 ">
                                                <p class="greenish is-5">
                                                    Status
                                                </p>
                                            </div>
                                            <div class="column is-3">
                                                <p class="greenish is-5">
                                                    Video
                                                </p>
                                            </div>
                                            {#if $contentStore.contents && $contentStore.contents.entries}
                                                {#each $contentStore.contents.entries as campaign}
                                                    <ContentCard
                                                        contentEntry={campaign}
                                                        onDeselect={removeContent}
                                                        onSelect={addContent}
                                                        selectedContebt={contentList}
                                                    />
                                                {/each}
                                            {/if}
                                        </div>
                                        {#if newContentModalOpen}
                                            <div class="modal is-active">
                                                <div
                                                    class="modal-background"
                                                    on:click={() =>
                                                        (newContentModalOpen = false)}
                                                />
                                                <div class="modal-content">
                                                    <div class="box">
                                                        <div class="field">
                                                            <!-- svelte-ignore a11y-label-has-associated-control -->
                                                            <label class="label"
                                                                >Name</label
                                                            >
                                                            <div
                                                                class="control"
                                                            >
                                                                <input
                                                                    class="input"
                                                                    type="text"
                                                                    placeholder="Bezeichnung"
                                                                    bind:value={newContentName}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div class="field">
                                                            <!-- svelte-ignore a11y-label-has-associated-control -->
                                                            <label class="label"
                                                                >URL</label
                                                            >
                                                            <div
                                                                class="control"
                                                            >
                                                                <input
                                                                    class="input"
                                                                    type="text"
                                                                    placeholder="Video URL"
                                                                    bind:value={newContentUrl}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div class="field">
                                                            <!-- svelte-ignore a11y-label-has-associated-control -->
                                                            <label class="label"
                                                                >Upload</label
                                                            >
                                                            <div
                                                                class="control"
                                                            >
                                                                <div
                                                                    class="columns"
                                                                >
                                                                    <div
                                                                        class="column is-10"
                                                                    >
                                                                        <input
                                                                            class="input"
                                                                            type="file"
                                                                            placeholder="Video URL"
                                                                            bind:files
                                                                        />
                                                                    </div>
                                                                    <div
                                                                        class="column is-2"
                                                                    >
                                                                        <button
                                                                            class="gradient-left"
                                                                            on:click={() =>
                                                                                uploadFile()}
                                                                            disabled={uploading}
                                                                        >
                                                                            Upload
                                                                        </button>
                                                                        {#if !uploading}
                                                                            {message}
                                                                        {/if}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="field is-grouped"
                                                        >
                                                            <div
                                                                class="control"
                                                            >
                                                                <button
                                                                    class="button gradient-left"
                                                                    on:click={createNewContent}
                                                                    >Anlegen</button
                                                                >
                                                            </div>
                                                            <div
                                                                class="control"
                                                            >
                                                                <button
                                                                    class="button gradient-left"
                                                                    on:click={() =>
                                                                        (newContentModalOpen = false)}
                                                                    >Abbrechen</button
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <button
                                                    class="modal-close is-large"
                                                    aria-label="close"
                                                    on:click={() =>
                                                        (newContentModalOpen = false)}
                                                />
                                            </div>
                                        {/if}
                                    </div>
                                </div>
                            </div>
                        {/if}
                    </div>
                </div>

                <!--<section class="mui-1mmxj7b">
                        <span style="font-size: 0px;" />
                        <div
                            class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-2 MuiGrid-direction-xs-column MuiGrid-wrap-xs-nowrap mui-129o4pc"
                        >
                            <div
                                class="MuiGrid-root MuiGrid-container MuiGrid-item mui-ja9bxb"
                            >
                                <div
                                    class="MuiGrid-root MuiGrid-item mui-1wxaqej"
                                >
                                    <h6
                                        class="MuiTypography-root MuiTypography-h6 mui-1y6miyj"
                                    >
                                        Creatives
                                    </h6>
                                </div>
                                <div
                                    class="MuiGrid-root MuiGrid-item mui-1wxaqej"
                                >
                                    <button
                                        class="MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-sizeMedium MuiButton-outlinedSizeMedium MuiButtonBase-root  mui-p0wysb"
                                        tabindex="0"
                                        type="button"
                                        >Select<span
                                            class="MuiTouchRipple-root mui-w0pj6f"
                                        /></button
                                    >
                                </div>
                            </div>
                            <div
                                class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 mui-15j76c0"
                            />
                            <div
                                class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 mui-15j76c0"
                            >
                                <div
                                    class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-4 mui-1tz8m30"
                                >
                                    <div
                                        class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 mui-15j76c0"
                                    >
                                        <div
                                            class="MuiGrid-root MuiGrid-container mui-1b1jvye"
                                        >
                                            <h6
                                                class="MuiTypography-root MuiTypography-subtitle2 mui-oc6lw9"
                                            >
                                                Landscape
                                            </h6>
                                            <div
                                                class="MuiGrid-root MuiGrid-item mui-1wxaqej"
                                            >
                                                <div
                                                    class="MuiGrid-root MuiGrid-container MuiGrid-item mui-n6nfem"
                                                >
                                                    <div
                                                        class="MuiFormGroup-root mui-1h7anqn"
                                                    >
                                                        <label
                                                            class="MuiFormControlLabel-root MuiFormControlLabel-labelPlacementEnd mui-1jaw3da"
                                                            ><span
                                                                aria-label="Note: This is an experimental feature, which is still in testing phase and will not run yet on all screens in the network. Please contact support@framen.io for further details."
                                                                class=""
                                                                ><span
                                                                    class="MuiSwitch-root MuiSwitch-sizeSmall mui-vd1cxy"
                                                                    ><span
                                                                        class="MuiSwitch-switchBase MuiSwitch-colorPrimary MuiButtonBase-root MuiSwitch-switchBase MuiSwitch-colorPrimary PrivateSwitchBase-root mui-1wiewz5"
                                                                        ><input
                                                                            class="MuiSwitch-input PrivateSwitchBase-input mui-1m9pwf3"
                                                                            type="checkbox"
                                                                        /><span
                                                                            class="MuiSwitch-thumb mui-19gndve"
                                                                        /><span
                                                                            class="MuiTouchRipple-root mui-w0pj6f"
                                                                        /></span
                                                                    ><span
                                                                        class="MuiSwitch-track mui-1ju1kxc"
                                                                    /></span
                                                                ></span
                                                            >
                                                            <p
                                                                class="MuiTypography-root MuiTypography-body2 mui-8294h9"
                                                            >
                                                                QR Code
                                                            </p></label
                                                        >
                                                    </div>
                                                    <button
                                                        class="MuiButtonBase-root Mui-disabled MuiIconButton-root Mui-disabled MuiIconButton-sizeLarge mui-1w8s6so"
                                                        tabindex="-1"
                                                        type="button"
                                                        disabled=""
                                                        ><svg
                                                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium mui-vubbuv"
                                                            focusable="false"
                                                            aria-hidden="true"
                                                            viewBox="0 0 24 24"
                                                            data-testid="SettingsIcon"
                                                            ><path
                                                                d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
                                                            /></svg
                                                        ></button
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="MuiBox-root mui-19mxx9t">
                                            <div
                                                class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiAlert-root MuiAlert-outlinedWarning MuiAlert-outlined mui-1pw8y72"
                                                role="alert"
                                            >
                                                <div
                                                    class="MuiAlert-icon mui-1l54tgj"
                                                >
                                                    <svg
                                                        class="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit mui-1cw4hi4"
                                                        focusable="false"
                                                        aria-hidden="true"
                                                        viewBox="0 0 24 24"
                                                        data-testid="ReportProblemOutlinedIcon"
                                                        ><path
                                                            d="M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
                                                        /></svg
                                                    >
                                                </div>
                                                <div
                                                    class="MuiAlert-message mui-1w0ym84"
                                                >
                                                    You have no creatives
                                                    selected. Please upload your
                                                    content to get started.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 mui-15j76c0"
                                    >
                                        <div
                                            class="MuiGrid-root MuiGrid-container mui-1b1jvye"
                                        >
                                            <h6
                                                class="MuiTypography-root MuiTypography-subtitle2 mui-oc6lw9"
                                            >
                                                Portrait
                                            </h6>
                                            <div
                                                class="MuiGrid-root MuiGrid-item mui-1wxaqej"
                                            >
                                                <div
                                                    class="MuiGrid-root MuiGrid-container MuiGrid-item mui-n6nfem"
                                                >
                                                    <div
                                                        class="MuiFormGroup-root mui-1h7anqn"
                                                    >
                                                        <label
                                                            class="MuiFormControlLabel-root MuiFormControlLabel-labelPlacementEnd mui-1jaw3da"
                                                            ><span
                                                                aria-label="Note: This is an experimental feature, which is still in testing phase and will not run yet on all screens in the network. Please contact support@framen.io for further details."
                                                                class=""
                                                                ><span
                                                                    class="MuiSwitch-root MuiSwitch-sizeSmall mui-vd1cxy"
                                                                    ><span
                                                                        class="MuiSwitch-switchBase MuiSwitch-colorPrimary MuiButtonBase-root MuiSwitch-switchBase MuiSwitch-colorPrimary PrivateSwitchBase-root mui-1wiewz5"
                                                                        ><input
                                                                            class="MuiSwitch-input PrivateSwitchBase-input mui-1m9pwf3"
                                                                            type="checkbox"
                                                                        /><span
                                                                            class="MuiSwitch-thumb mui-19gndve"
                                                                        /><span
                                                                            class="MuiTouchRipple-root mui-w0pj6f"
                                                                        /></span
                                                                    ><span
                                                                        class="MuiSwitch-track mui-1ju1kxc"
                                                                    /></span
                                                                ></span
                                                            >
                                                            <p
                                                                class="MuiTypography-root MuiTypography-body2 mui-8294h9"
                                                            >
                                                                QR Code
                                                            </p></label
                                                        >
                                                    </div>
                                                    <button
                                                        class="MuiButtonBase-root Mui-disabled MuiIconButton-root Mui-disabled MuiIconButton-sizeLarge mui-1w8s6so"
                                                        tabindex="-1"
                                                        type="button"
                                                        disabled
                                                        ><svg
                                                            class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium mui-vubbuv"
                                                            focusable="false"
                                                            aria-hidden="true"
                                                            viewBox="0 0 24 24"
                                                            data-testid="SettingsIcon"
                                                            ><path
                                                                d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
                                                            /></svg
                                                        ></button
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div class="MuiBox-root mui-19mxx9t">
                                            <div
                                                class="MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation0 MuiAlert-root MuiAlert-outlinedWarning MuiAlert-outlined mui-1pw8y72"
                                                role="alert"
                                            >
                                                <div
                                                    class="MuiAlert-icon mui-1l54tgj"
                                                >
                                                    <svg
                                                        class="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit mui-1cw4hi4"
                                                        focusable="false"
                                                        aria-hidden="true"
                                                        viewBox="0 0 24 24"
                                                        data-testid="ReportProblemOutlinedIcon"
                                                        ><path
                                                            d="M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
                                                        /></svg
                                                    >
                                                </div>
                                                <div
                                                    class="MuiAlert-message mui-1w0ym84"
                                                >
                                                    You have no creatives
                                                    selected. Please upload your
                                                    content to get started.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section> -->
            </div>
        </div>
    </div>
</div>

<style>
    /* .field {
        max-width: 73%;
    }

    .field-body {
        width: 100%;
    } */

    .container {
        height: calc(90vh - 30px);
    }
    .what {
        font-weight: 700;
        font-size: 1.7rem;
        padding-bottom: 2rem;
    }

    .full-1_75rem {
        width: calc(100% - 1.75rem);
    }

    select {
        background-image: linear-gradient(
            to right,
            #14acab 0%,
            #238aae 51%,
            #2765af 100%
        ) !important;
        color: white !important;
    }

    ::after {
        border-color: white !important;
    }

    /* .card {
        border-radius: 100px;
        padding: 2rem 4rem;
    } */

    .label {
        text-align: left;
        font-weight: 600 !important;
        font-size: 1.3rem;
        padding-top: 0.375rem;
    }

    .field-label {
        flex-grow: 1.5 !important;
    }

    .greenish {
        text-align: center;
        background-color: #14acab;
        border-radius: 40px;
        color: white;
        height: 50px;
        margin: 0 11px;
        padding: 13px;
    }

    .greenish-plus {
        text-align: center;
        background-color: #14acab;
        border-radius: 40px;
        color: white;
        height: 50px;
        width: 50px;
        margin: auto;
        padding: 13px;
        font-size: 2rem;
        font-weight: 600;
        line-height: 25px;
    }

    .greenish-plus:hover {
        cursor: pointer;
    }

    .c-pointer {
        cursor: pointer;
    }

    .gradient-left {
        background-image: linear-gradient(
            to right,
            #14acab 0%,
            #238aae 51%,
            #2765af 100%
        ) !important;
        color: white !important;
    }

    .f-white {
        color: white !important;
    }
    .b-seethrough {
        background-color: transparent !important;
    }

    .mb-0 {
        margin-bottom: 0 !important;
    }

    .modal-stations {
        width: 80%;
        background-color: #f5f5f5;
        border-radius: 20px;
        padding: 2rem;
    }

    .flex {
        justify-content: center;
        display: flex;
        margin: auto;
    }
</style>
